<div *ngIf="permissionData$| async as permissionData">
<app-bread-crumbs [navigationRoute]="currentRoute" [currentPageString]="currentPageString" [clickHandler]="returnToRFQ"
  (buttonActionHandler)="buttonHandler($event)"
  [isReadOnly]="isReadOnly && !permissionData.ability.can('update', permissionData.formAor)"
  [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage">
</app-bread-crumbs>
</div>
<!-- kiv for when there is actual load from the api calls -->
<!-- <div class="load-spinner" *ngIf="isDataLoading">
      <mat-spinner class="add-item-spinner"></mat-spinner>
      <p>Loading necessary data...</p>
    </div> -->

<button class="scroll-top-btn" style="white-space: pre" type="flat-button" (click)="scrollTop()" title="Jump to top">
  <mat-icon>arrow_upward</mat-icon>
</button>
<div class="page-container" *ngIf="permissionData$| async as permissionData">
  <div *ngIf="currError || itemErrorShow" style="transform:translateY(-13px)">
    <div class="outer-container">
      <div class="header-error">
        <div><mat-icon class="icon">error</mat-icon></div>
        <ng-container>
          <span [innerHTML]="errMsg"></span>
        </ng-container>
      </div>
    </div>
  </div>
  <app-layout class="container--form">
    <app-form-header *ngIf="isReadOnly && (purchaseType === 'rfq' || purchaseType === 'corporatecard')"
      class="formHeader" [formHeaderElementList]="formStatus"></app-form-header>
    <mat-tab-group class="pt-3" #addItemTab dynamicHeight mat-stretch-tabs="false" mat-align-tabs="start"
      [(selectedIndex)]="selectedTabIndex">
      <mat-tab label="Detail" bodyClass="mt-4">
        <app-item-info [addItemForm]="addItemForm" [purchaseType]="purchaseType" [isReadOnly]="isReadOnly && !permissionData.ability.can('update', permissionData.formAor, AbilityField.AOR_Detail)"></app-item-info>
        <div class="budgetBtn">
          <app-button tabindex='0' (keypress)="nextSection()" (click)="nextSection()" name="Next" type="flat-button"
            class="padBtn mar-r-10"></app-button>
        </div>
      </mat-tab>
      <mat-tab label="Price" bodyClass="mt-4">
        <app-item-price (currErrorEvent)="handleCurrExError($event)" [addItemPriceForm]="addItemPriceForm"
          [BudgetForm]="budgetAllocationForm" [isReadOnly]="isReadOnly && !permissionData.ability.can('update', permissionData.formAor, AbilityField.AOR_Price)"></app-item-price>
        <span>&nbsp;</span>
        <div class="budgetBtn">
          <app-button tabindex='0' (keypress)="previousSection()" (click)="previousSection()" name="Previous" type="basic"></app-button>
          <app-button tabindex='0' (keypress)="nextSection()" (click)="nextSection()" name="Next" type="flat-button"
            class="padBtn mar-r-10 budgetBtn"></app-button>
        </div>
      </mat-tab>
      <mat-tab label="Budget allocation" bodyClass="mt-4">
        <app-item-budget [BudgetForm]="budgetAllocationForm" (updateBudgetForm)="updateBudgetForm($event)" 
        (budgetTypeValue)="handleBudgetTypeChange($event)"
          [isReadOnly]="isReadOnly && !permissionData.ability.can('update', permissionData.formAor, 'budget-allocation')"></app-item-budget>

        <div class="budgetBtn">
          <app-button tabindex='0' (keypress)="previousSection()" (click)="previousSection()" name="Previous" type="basic"></app-button>
          <app-button *ngIf="purchaseType === 'tender' || IsCapitalUsageRequirementEnable" tabindex='0' (keypress)="nextSection()" (click)="nextSection()" name="Next" type="flat-button"
            class="padBtn mar-r-10 budgetBtn"></app-button>
        </div>
      </mat-tab>

      <mat-tab  label="Capital usage requirements" bodyClass="mt-4" *ngIf="IsCapitalUsageRequirementEnable">
        <app-capital-usage-requirements [addCapitalUsageRequirementForm]="addCapitalUsageRequirementForm" [isReadOnly]="isReadOnly && !permissionData.ability.can('update', permissionData.formAor)"
          [priceQuantity]="addItemPriceForm.value.Quantity"></app-capital-usage-requirements>
        <div class="budgetBtn">
          <app-button tabindex='0' (keypress)="previousSection()" (click)="previousSection()" name="Previous" type="basic"
            class="padBtn mar-r-10 budgetBtn"></app-button>
        </div>
      </mat-tab>


      <mat-tab label="Add-on" bodyClass="mt-4" *ngIf="purchaseType === 'tender' || purchaseType === 'dc'">
        <app-item-add-on (getAddOnData)="getAddOnData($event)" [isReadOnly]="isReadOnly && !permissionData.ability.can('update', permissionData.formAor)"
          [priceQuantity]="addItemPriceForm.value.Quantity"></app-item-add-on>
        <div class="budgetBtn">
          <app-button tabindex='0' (keypress)="previousSection()" (click)="previousSection()" name="Previous" type="basic"
            class="padBtn mar-r-10 budgetBtn"></app-button>
        </div>
      </mat-tab>
    </mat-tab-group>
  </app-layout>
</div>